import { produce } from 'immer'
import {
  GET_ORG_MEMBER_SUCCESS,
  GET_PERSON_STATISTICS_SUCCESS,
  GetOrgMemberActions,
  GetPersonStatisticsActions,
} from 'src/app/PeopleDetailFlyout/redux/peopleDetailFlyout.actions'
import {
  GET_ORGANIZATION_MEMBERS_SUCCESS,
  GetPeopleMembersActions,
} from 'src/app/PeopleMembers/redux/peopleMembers.actions'
import {
  GET_ORGANIZATION_OWNERS_AND_ADMINS_SUCCESS,
  GetPeopleOwnersAndAdminsActions,
} from 'src/app/PeopleOwnersAndAdmins/redux/peopleOwnersAndAdmins.actions'
import {
  REMOVE_USER_FROM_ORGANIZATION_SUCCESS_ACTION,
  RemoveUserFromOrganizationActions,
} from 'src/app/RemoveUserFromOrganization/redux/removeUserFromOrganization.actions'
import { UserConnectionResponse } from 'src/models/people.models'
import { UserListResponse } from 'src/models/user.models'
import {
  PUT_ORGANIZATION_ROLE_SUCCESS,
  PutOrganizationRoleActions,
} from 'src/redux/actions/data/organizations.actions'
import {
  PATCH_ORG_MEMBER_SUCCESS,
  PatchOrgMemberActions,
  UPDATE_MEMBER_DEPARTMENT,
  UpdateMemberDepartmentAction,
} from 'src/redux/actions/data/users.actions'

export interface MembersState {
  listResponses: Record<string, UserListResponse>
  ownersAndAdminsListResponses: Record<string, UserListResponse>
  contact?: UserConnectionResponse[]
}

export const initialState: MembersState = {
  listResponses: {},
  ownersAndAdminsListResponses: {},
}

export type Actions =
  | GetPeopleMembersActions
  | GetOrgMemberActions
  | GetPeopleOwnersAndAdminsActions
  | GetPersonStatisticsActions
  | RemoveUserFromOrganizationActions
  | PutOrganizationRoleActions
  | PatchOrgMemberActions
  | UpdateMemberDepartmentAction

const MembersReducer = (
  state: MembersState = initialState,
  action: Actions,
): MembersState => {
  return produce(state, (draft) => {
    switch (action.type) {
      case GET_ORGANIZATION_MEMBERS_SUCCESS: {
        draft.listResponses = action.payload.users.reduce(
          (acc, curr) => ({
            ...acc,
            [curr.id]: curr,
          }),
          draft.listResponses,
        )
        return draft
      }

      case GET_ORGANIZATION_OWNERS_AND_ADMINS_SUCCESS: {
        draft.ownersAndAdminsListResponses = action.payload.users.reduce(
          (acc, curr) => ({
            ...acc,
            [curr.id]: curr,
          }),
          draft.ownersAndAdminsListResponses,
        )
        return draft
      }

      case PATCH_ORG_MEMBER_SUCCESS:
      case PUT_ORGANIZATION_ROLE_SUCCESS:
      case GET_ORG_MEMBER_SUCCESS: {
        draft.listResponses = {
          ...draft.listResponses,
          [action.payload.id]: action.payload,
        }
        return draft
      }
      case GET_PERSON_STATISTICS_SUCCESS: {
        draft.listResponses = {
          ...draft.listResponses,
          [action.userId]: {
            ...draft.listResponses[action.userId],
            statistics: action.payload,
          },
        }
        return draft
      }
      case REMOVE_USER_FROM_ORGANIZATION_SUCCESS_ACTION: {
        draft.listResponses = Object.keys(draft.listResponses)
          .filter((id) => id !== action.payload.user.id)
          .reduce(
            (acc, curr) => ({
              ...acc,
              [curr]: draft.listResponses[curr],
            }),
            {},
          )
        return draft
      }

      case UPDATE_MEMBER_DEPARTMENT: {
        draft.listResponses = Object.entries(draft.listResponses).reduce(
          (acc, curr) => {
            if (action.payload.userIds.includes(curr[0])) {
              return {
                ...acc,
                [curr[0]]: {
                  ...curr[1],
                  department: action.payload.department,
                },
              }
            }
            return {
              ...acc,
              [curr[0]]: curr[1],
            }
          },
          {},
        )
        return draft
      }
    }
  })
}

export default MembersReducer
